/* eslint-disable  */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Header } from 'semantic-ui-react';
import dayjs from 'dayjs';
import { actions } from './sagaSlice';
import FormLong from './FormLong';
import FormShort from './FormShort';
import Dimmer from '+/Dimmer';
import usePrint from '+/hooks/usePrint';
import { FlexBox } from '../../styles/components';
import { PrintDate } from '../../shared/components/PrintDate';
const utc = require('dayjs/plugin/utc');
dayjs.extend(utc);

const ViewEval = props => {

    const {
        readOne, evaluation, isFetching, match
    } = props;
    const { department_id, eval_id, employee_id } = match.params;
    const { ref, Trigger } = usePrint();

    const [actualJobTitle, setActualJobTitle] = React.useState('');

    useEffect(() => {
        setActualJobTitle(evaluation?.data?.actual_job_title || '');
    }, [evaluation]);

    useEffect(() => {

        readOne({
            department_id,
            eval_id,
            employee_id
        });
    }, [department_id, employee_id, eval_id, readOne]);


    if (!evaluation || isFetching) return <Dimmer />;

    const handleCommentSection = () => {

        const formTable = document.getElementById('eval-section-comments')
        const formTextArea = document.getElementById('eval-section-comments-textarea')

        const formTable2 = document.getElementById('eval-section-regional-comments')
        const formTextArea2 = document.getElementById('eval-section-regional-comments-textarea')
        
        if (formTextArea.value.length === 0) {
            formTable.classList.toggle('hide')
        };

        if (formTextArea2 && formTextArea2.value.length === 0) {
            formTable2.classList.toggle('hide')
        };

    };

    return (
        <div className='eval-form print portait print-mt' ref={ref}>
            <Trigger onBeforeGetContent={handleCommentSection} onAfterPrint={handleCommentSection}/>
            <div style={{ textAlign: 'center' }}>
                <FlexBox justifyContent='flex-end'>
                    <span>
                        <strong>Kronos ID:</strong> {evaluation.employee.kronos_id}
                    </span>
                </FlexBox>
                <PrintDate isForPDF={false}/>
                <Header content='United Property Management' subheader='Performance Review' size='large'/>
                <div style={{ fontSize: '12px' }}>
                    <div>
                        <strong>Core Value:</strong> Safety, Courtesy, Integrity, Efficiency.
                    </div>
                    <div>
                        <strong>Our mission</strong> is to be the most complete and comprehensive property management
                    company by providing the residents of our communities with attractive,
                    affordable housing and quality service that exceeds expectations.
                    </div>
                    <div>
                        <strong>Our company goal</strong> is stated in our motto: <i>"Paying Attention to Every Detail"</i>
                    </div>
                </div>
                <FlexBox justifyContent='flex-end'>
                    <span>
                        <strong>Job Title:</strong>
                        <input
                            value={actualJobTitle}
                            onChange={e => {
                                setActualJobTitle(e.target.value);
                            }}
                        />
                    </span>
                </FlexBox>
                <FlexBox justifyContent='space-between'>
                    <span>
                        <strong>Employee Name:</strong> {` ${evaluation.employee.name}`}
                    </span>
                    <span>
                        <strong>Eval Role:</strong> {` ${evaluation.employee.title.name}`}
                    </span>
                </FlexBox>
                <FlexBox justifyContent='space-between'>
                    <span>
                        <strong>Hire Date:</strong> {` ${dayjs.utc(evaluation.employee.hire_date).format('MM/DD/YYYY')}`}
                    </span>
                    <span>
                        <strong>Department(s):</strong> {evaluation.employee.departments.map(dept => dept.name).join(', ')}
                    </span>
                </FlexBox>
            </div>
            { evaluation.type === 'long' && <FormLong evaluation={evaluation} actualJobTitle={actualJobTitle}/> }
            { evaluation.type === 'short' && <FormShort evaluation={evaluation} actualJobTitle={actualJobTitle}/> }
        </div>
    );
};


const mapStateToProps = (state, ownProps) => ({
    evaluation: state.evals.data[ownProps.match.params.eval_id],
    isFetching: state.evals.isFetching
});

export default connect(mapStateToProps, actions)(ViewEval);
